import { useState, useEffect, useRef, memo } from 'react';
import Plyr from 'plyr-react';
import 'plyr-react/plyr.css';
import { Link } from 'react-router-dom';
import Countdown from '../../../../components/misc/countdown';
import { duration } from '../../../../assets/scripts/script';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PlayVideo = memo(
  ({
    title,
    poster,
    video,
    nextIsLive,
    nextTitle,
    nextThumb,
    nextDuration,
    nextId,
    nextChannelName,
    autoplay
  }) => {
    const ref = useRef();
    const [ready, setReady] = useState(false);
    const [end, setEnd] = useState(false);
    const [plyrProps, setPlyrProps] = useState({});

    const [x, setX] = useState('');
    const [f, setF] = useState(0);

    const [valid, setValid] = useState(true);

    useEffect(() => {
      setEnd(false);
      setPlyrProps({
        source: {
          type: 'video',
          title: title,
          sources: [
            {
              src: video,
              type: 'video/mp4',
              size: 720
            }
          ],
          poster: poster
        },
        options: {
          autoplay: true,
          hideControls: true,
          playsinline: true,
          disableContextMenu: true,
          speed: { selected: 1, options: [0.75, 1, 1.25] },
          controls: [
            'play-large', // The large play button in the center
            // 'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
            'progress', // The progress bar and scrubber for playback and buffering
            'current-time', // The current time of playback
            'duration', // The full duration of the media
            'mute', // Toggle mute
            'volume', // Volume control
            'captions', // Toggle captions
            'settings', // Settings menu
            'pip', // Picture-in-picture (currently Safari only)
            'airplay', // Airplay (currently Safari only)
            // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
            'fullscreen' // Toggle fullscreen
          ]
        }
      });
        }, [video]);

    useEffect(() => {
      let temp = valid;
      if (ref.current.plyr.source !== null) {
        if (ref.current.plyr.eventListeners.length !== 0) {
          let player = ref.current.plyr;

          player.on('ended', () => {
            if (autoplay.current.ariaChecked === 'true') {
              setEnd(true);
            } else {
              setEnd(false);
            }
          });

          if (f === 0) {
            setF(f + 1);
            setX(ref.current.plyr.source);
          } else if (x === ref.current.plyr.source) {
            setReady(!ready);
            temp = false;
            setValid(false);
          } else {
            temp = true;
            setValid(true);
            setX(ref.current.plyr.source);
          }

          //   player.on('loadedmetadata', () => {
          //     console.log(player.media.duration);
          //     console.log('trigger hh');
          // })

          // if(player.media){
          //     setInterval( function() {
          //       // POST current time and state to the server
          //       if(player.media.duration === player.currentTime){
          //         console.log('end');
          //       }
          //     }, 3000);
          //     //console.log(player.currentTime);
          // }

          // if (temp){
          //   if(player.media !== null) {
          //               setInterval( function() {
          //               // POST current time and state to the server
          //               if(player.media !== null) {
          //               if(player.media.duration === player.currentTime){
          //                 console.log('end');
          //               }
          //             }
          //             }, 3000);
          //           }
          // }
        } else {
          setReady(!ready);
        }
      } else {
        setReady(!ready);
      }
    }, [ready, video]);

    return (
      video !== '' && (
        <div className="relative h-full">
          <div
            className={`${
              !end ? 'hidden' : ''
            } bg-black rounded-md z-40 top-0 absolute w-full h-full`}>
            <div className="centered-axis-xy w-[20rem] xs:w-[22rem] sm:w-[26rem] md:w-[32rem] lg:w-[34rem]">
              <p className="text-sm mb-2 font-semibold">
                Up Next in{' '}
                {end && (
                  <Countdown
                    seconds={10}
                    src={`/videos/watch/${nextId}/${nextTitle
                      .replace(/[\s+-]/g, '-')
                      .toLowerCase()}`}
                  />
                )}
              </p>
              <Link
                to={`/videos/watch/${nextId}/${nextTitle.replace(/[\s+-]/g, '-').toLowerCase()}`}
                className="cursor grid grid-cols-2 gap-4">
                <div className="relative thumbnail aspect-video rounded-md">
                  <LazyLoadImage
                    className="w-full h-full rounded-md object-cover aspect-video"
                    alt={nextTitle}
                    src={nextThumb}
                    placeholderSrc="https://ceflix.org/images/fallback.png"
                  />
                  {nextIsLive !== '1' ? (
                    <span className="absolute bottom-0 right-0 text-xxs px-2 py-1 m-1 rounded-sm bg-neutral-900/90">
                      {duration(nextDuration)}
                    </span>
                  ) : (
                    <span className="absolute bottom-0 right-0 text-xxs px-2 py-1 m-1 rounded-sm bg-red-900/90">
                      Live
                    </span>
                  )}
                </div>
                <div className="flex flex-col text-sm">
                  <h1 className="truncate-search font-semibold capitalize">{nextTitle}</h1>
                  <p className="text-xs text-gray-300 font-medium capitalize">{nextChannelName}</p>
                </div>
              </Link>
              <div className="grid grid-cols-2 font-medium mt-4 gap-2 uppercase text-xs sm:text-sm md:text-base">
                <button
                  type="button"
                  className="transition bg-neutral-900 hover:bg-neutral-800 uppercase rounded-full py-2"
                  onClick={() => setEnd(false)}>
                  Cancel
                </button>
                <Link
                  to={`/videos/watch/${nextId}/${nextTitle.replace(/[\s+-]/g, '-').toLowerCase()}`}
                  className="transition text-center bg-neutral-600 hover:bg-neutral-500 uppercase rounded-full py-2">
                  Play Now
                </Link>
              </div>
            </div>
          </div>
          <Plyr
            ref={ref}
            source={plyrProps.source}
            options={plyrProps.options}
          />
        </div>
      )
    );
  }
);

export default PlayVideo;
